import {makeStyles} from '@material-ui/core'

export const useStyles = makeStyles(() => ({
    container: {
      display: 'flex',
      flexDirection: 'column',
      maxWidth: '420px',
      gap: '4px',
      borderRadius: '8px',
      padding: '16px',
      backgroundColor: '#f1f5f9',
    },
    title: {
      fontWeight: 700,
      fontSize: '12px',
      color: 'rgba(0, 0, 0, 0.6)',
    },
    list: {
      display: 'flex',
      flexDirection: 'column',
      paddingLeft: '16px',
      margin: 0,
      fontWeight: 400,
      fontSize: '12px',
    },
    button: {
      border: 'none',
      backgroundColor: 'transparent',
      fontSize: '12px',
      color: 'rgba(41, 121, 255, 0.87)',
      cursor: 'pointer',
      padding: 0,

      '&:hover': {
        textDecoration: 'underline',
      }
    }
  }
))
